import React from "react";
import "../css/paysuccess.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { useLocation } from "react-router-dom";

const PaySuccess = () => {
  const state = new URLSearchParams(useLocation().search).get("state");
  const isSuccess = state === "success";
  return (
    <>
      <div className="successDiv">
        <div className="success-container">
          <div className="modal-content">
            <div className={`checkmark-circle ${isSuccess ? "" : "cancelled"}`}>
              <FontAwesomeIcon icon={faCheck} />
              <div className="checkmark"></div>
            </div>
            <p>{isSuccess ? "Payment successful. Your order is being processed." : "Payment cancelled. Your order has not been charged."}</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default PaySuccess;
